import React, { useState } from "react";
import {
    Button,
    Grid,
    IconButton,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import ChatWindow from "../../ConversationsRevamp/ChatWindow";
import ConversationMediaUploadPopup from "../../../../../components/common/Conversation/ConversationMediaUploadPopup";
import { AttachFile } from "@material-ui/icons";
import { FrolaEditor } from "../../../../../components/common";
import { Close } from "../../../LeftNav/SvgIcons";


const useStyles = makeStyles((theme) => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "20px",
    },
    paper: {
        backgroundColor: "#FFFFFF",
        boxShadow: "0px 0px 6px 0px #00000040",
        borderRadius: "20px",
        width: "815px",
        '& .endUserChatWindowWrapper':{
            height:"500px"
        },
        '& .chatEditorSocial':{
            width:"100%",
            borderRadius:"0px 0px 20px 20px",
            padding:"20px",
        },
        '& .conversationFileUpload':{
            marginRight:"120px",
        },
        '& .chatEditor':{
            borderRadius:"0px 0px 20px 20px",
            padding:"20px",
            width:"100%",
        },
        '& .chatEditor i':{
            bottom:"20px",
            right:"20px",
        },
        '& .conv-attachment-icon':{
            right:"20%",
        },
        '& .conv-attachment-icon-social':{
            right:"20%",
        },
        '& .chatEditorSocial i':{
            bottom:"20px",
            right:"20px",
        }
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        borderBottom: "2px solid #E2E5E9",
        padding: "23px 33px 23px 41px;",
        background: "#3699FF",
        borderTopRightRadius: "20px",
        borderTopLeftRadius: "20px",
    },
    customerTypo: {
        fontSize: "22px",
        fontFamily: "Roboto",
        fontWeight: 700,
        color: "#fff",
    },
    innerBody: {
        overflowY: "auto",
    },
    chooseCustomerHeading: {
        fontSize: "22px",
        fontFamily: "Roboto",
        fontWeight: 700,
        color: "#181C32",
    },
    text: {
        fontSize: "14px",
        fontWeight: 400,
        fontFamily: "Roboto",
        margin: "16px 0px",
        color: "#434D56",
    },
    content: {
        display: "flex",
        justifyContent: "space-between",
        padding: "13px 18px 17px 20px",
    },
    closIcon: {
        padding: "unset",
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
    mainCustomerPricing: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
    },
    mainBody: {
        padding: "32px",
    },
    customReleaseFilter: {
        fontSize: "12px",
        "& .MuiOutlinedInput-input": {
            padding: "13px 12px 13px 30px !important",
        },
    },
    chatWindow:{
        width:"100%",
        marginBottom:"15px",
    }
}));

export const ChatModal = ({
    leadData,
    openPopup,
    setOpenPopup,
    roomMsgs,
    onSendMessage
}) => {
    const classes = useStyles();
    const [fileName, setFileName] = useState("");
    const [isUpload, setIsUpload] = useState(false);
    const [uploadFile, setUploadFile] = useState("");
    const [comDescription, setComDescription] = useState("");
    const [isEmptyMessage , setIsEmptyMessage] = useState(false);

    const onClose = () => {
        setOpenPopup(null);
    };

    const onHandleComDescription = model => {
        if(leadData?.platform === "Facebook" || 
           leadData?.platform === "Instagram"){
          setComDescription(model.target.value);
          setIsEmptyMessage(Boolean(model.target.value?.trim()))
        }else{
          setComDescription(model);
          let removedEntities = model?.replace(/&nbsp;/g, ' ');
          let withoutTags = removedEntities?.replace(/<[^>]*>/g, '');
          let cleanedStr = withoutTags?.replace(/\s+/g, '').trim();
          setIsEmptyMessage(Boolean(cleanedStr))
        }
      };
      
      function truncate(item) {
        if (item && item.length > 15) {
          return item.substring(0, 13) + "...";
        }
        return item;
      }
    return (
        <Grid>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={openPopup}
                onClose={onClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={openPopup}>
                    <Grid container className={classes.paper}>
                        <Grid item xs={12} className={classes.header}>
                            <Typography className={classes.customerTypo}>{`${leadData?.firstName} ${leadData?.lastName}`}</Typography>
                            <IconButton className={classes.closIcon} onClick={onClose}>
                            <Close />
                            </IconButton>
                        </Grid>
                        <Grid className={classes.chatWindow}>
                        <ChatWindow roomMsgs={roomMsgs} />
                        </Grid>
                        {/* <span className={
                            leadData?.platform === "Facebook" ||
                                leadData?.platform === "Instagram"
                                ? 'chatEditorSocial' : 'chatEditor'}>
                            <div>
                                <span
                                    className={
                                        leadData?.platform === "Facebook" ||
                                            leadData?.platform === "Instagram" 
                                            ? "conv-attachment-icon-social" : "conv-attachment-icon"}
                                    onClick={() => {
                                        setIsUpload(true);
                                    }}>
                                    <div className='conversationFileUpload'>{fileName}</div>
                                    <AttachFile />
                                </span>
                                <FrolaEditor
                                    model={comDescription}
                                    conversationPlateform={leadData?.platform}
                                    onHandleModelChange={model => onHandleComDescription(model)}
                                    comDescription={comDescription}
                                />
                            </div>
                            <i className='sendBtn'>
                                {fileName && (
                                    <>
                                        <p className='textEditorAttachment'>
                                            <IconButton
                                                onClick={() => {
                                                    setUploadFile(null);
                                                    setFileName(null);
                                                }}>
                                                <Cross />
                                            </IconButton>
                                            {truncate(fileName)}
                                        </p>

                                        <IconButton
                                            aria-label='delete'
                                            style={{
                                                backgroundColor: "transparent",
                                            }}>
                                            <AttachFile />
                                        </IconButton>
                                    </>
                                )}
                                <Button
                                    color='primary'
                                    variant='contained'
                                    disabled={!isEmptyMessage && !fileName}
                                    onClick={() => {
                                        onSendMessage({
                                            messageContent: comDescription,
                                            clearContent: () => setComDescription(""),
                                            fileName: fileName,
                                            uploadFile: uploadFile,
                                        });
                                        setUploadFile(null);
                                        setFileName(null);
                                    }}>
                                    Send
                                </Button>
                            </i>
                        </span>
                        {isUpload && (
                            <ConversationMediaUploadPopup
                                isMultiple={false}
                                openPopup={isUpload}
                                closePopup={() => setIsUpload(false)}
                                fileName={fileName}
                                setFileInfo={(name, file) => {
                                    setFileName(name);
                                    setUploadFile(file);
                                }}
                            />
                        )} */}
                    </Grid>
                </Fade>
            </Modal>
        </Grid>
    );
};
